import React from 'react';

const NewFilePopup = ({ show, onClose, onConfirm, fileName }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                <h2 className="text-xl font-bold text-red-600 mb-4">Upload Blood Test</h2>
                <p className="text-gray-700 mb-4">
                    You're about to upload the following file(s):
                </p>
                <div className="bg-gray-50 p-3 rounded-md mb-6 max-h-32 overflow-y-auto">
                    {Array.isArray(fileName) ? (
                        fileName.map((file, index) => (
                            <p key={index} className="text-gray-800 mb-1">{typeof file === 'string' ? file : file.name}</p>
                        ))
                    ) : (
                        <p className="text-gray-800">{typeof fileName === 'string' ? fileName : fileName?.name}</p>
                    )}
                </div>
                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                    >
                        Upload
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewFilePopup;
